import { render, staticRenderFns } from "./SP.vue?vue&type=template&id=39e8cf5c&scoped=true"
import script from "./SP.vue?vue&type=script&lang=js"
export * from "./SP.vue?vue&type=script&lang=js"
import style0 from "./SP.vue?vue&type=style&index=0&id=39e8cf5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e8cf5c",
  null
  
)

export default component.exports